import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import Breadcrumb from "../../Breadcrumb/modules/default";

const itemClassName =
  "shrink-0 whitespace-nowrap text-xs font-medium text-black-5 line-height-100";

const Breadcrumbs = ({ items, className }) => (
  <ScrollContainer
    className={classNames("w-full", className)}
    horizontal
    vertical={false}
  >
    <nav
      aria-label="Breadcrumb"
      className="flex align-center flex-nowrap gap-2 min-w-min whitespace-nowrap"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 ? (
              <span className={itemClassName} aria-hidden="true">
                /
              </span>
            ) : null}
            {item.href ? (
              <Breadcrumb href={item.href} className={itemClassName}>
                {item.label}
              </Breadcrumb>
            ) : (
              <span
                className={itemClassName}
                aria-current={isLast ? "page" : undefined}
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  </ScrollContainer>
);

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string
    })
  ).isRequired,
  className: PropTypes.string
};

export default Breadcrumbs;
